import { render, staticRenderFns } from "./YoutubeIcon.vue?vue&type=template&id=794d1a8d&"
import script from "./YoutubeIcon.vue?vue&type=script&lang=js&"
export * from "./YoutubeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports